export default __webpack_public_path__ + "static/media/plate.05325230.jpg";